
  import { Component, Vue } from 'vue-property-decorator'
  import BackNav from '@/components/BackNav/index.vue'
  import { editMicroStoreInfo } from '@/api/store'
  import { Debounce } from '@/core/decorator'
  import { Getter } from 'vuex-class'
  
  @Component({
    name: 'EditBusinessTime',
  })
  export default class EditBusinessTime extends Vue {
    @Getter companyId!: string
    takeStartTime = ''
    takeEndTime = ''
    pickupStartTime = ''
    pickupEndTime = ''
    currentTimeMap = {
      1: this.takeStartTime,
      2: this.takeEndTime,
      3: this.pickupStartTime,
      4: this.pickupEndTime,
    }

    
    pickerType = 1 // 默认选中开始时间
  
    created() {
      // 从路由参数获取初始值
    this.takeStartTime = this.$route.query.takeStartTime as string || '00:00'
    this.takeEndTime = this.$route.query.takeEndTime as string || '05:00'
    this.pickupStartTime = this.$route.query.pickupStartTime as string || '00:00'
    this.pickupEndTime = this.$route.query.pickupEndTime as string || '05:00'
    this.pickerType = Number(this.$route.query.pickerType) || 1
    // 同步更新 currentTimeMap 的值
      this.currentTimeMap = {
        1: this.takeStartTime,
        2: this.takeEndTime,
        3: this.pickupStartTime,
        4: this.pickupEndTime,
      }
    }

    get currentTime() {
      return this.currentTimeMap[this.pickerType] || ''
    }

    set currentTime(value: string) {
      this.currentTimeMap[this.pickerType] = value
    }
  
    @Debounce(500)
    async onSave() {
      if (!this.takeStartTime || !this.takeEndTime || !this.pickupStartTime || !this.pickupEndTime) {
        this.$toast('请选择完整的时间')
        return
      }
      try {
        const res = await editMicroStoreInfo({
            storeId: this.companyId,
            takeStartTime: `${this.takeStartTime}:00`,
            takeEndTime: `${this.takeEndTime}:00`,
            pickupStartTime: `${this.pickupStartTime}:00`,
            pickupEndTime: `${this.pickupEndTime}:00`
        })
        if (res.code === '000000') {
            this.$toast.success('保存成功')
            setTimeout(() => {
                this.$router.back()
            }, 1000)
        } else {
            this.$toast.fail(res.msg || '保存失败')
        }
      } catch (e) {
        console.error(e)
        this.$toast.fail('保存失败')
      }
    }
    
    togglePickerType(num: number) {
      this.pickerType = num
      // 切换时同步更新 currentTimeMap 的值，确保回显正确
      this.currentTimeMap[num] = this.getTimeByType(num)
    }

    getTimeByType(type: number): string {
      switch (type) {
        case 1:
          return this.takeStartTime
        case 2:
          return this.takeEndTime
        case 3:
          return this.pickupStartTime
        case 4:
          return this.pickupEndTime
        default:
          return ''
      }
    }
    
    onChange(picker) {
      // 实时更新显示的时间
      const values = picker.getValues()
      const timeStr = values.join(':')
      this.currentTimeMap[this.pickerType] = timeStr
      switch (this.pickerType) {
        case 1:
          this.takeStartTime = timeStr
          break
        case 2:
          this.takeEndTime = timeStr
          break
        case 3:
          this.pickupStartTime = timeStr
          break
        case 4:
          this.pickupEndTime = timeStr
          break
        default:
          break
      }
    }
  }
  